import { buildPatch } from 'api/builders';

export const update = ({
  id, locationId, deliverySettingId, dispatch,
}) => buildPatch({
  url: `sign_up/api/locations/${locationId}/delivery_settings/${deliverySettingId}/zones/${id}`,
  dispatch,
});
